module.exports = __webpack_public_path__ + "img/pc_phone_mb.bc712064.png";